var styles = {
  "horizonInput": "index-module_horizonInput__0fCuJ"
};
export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
